import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap } from 'rxjs/operators';
import { Observable, EMPTY, of } from 'rxjs';

import * as TagActions from '../actions/tag.actions';



@Injectable()
export class TagEffects {

  loadTags$ = createEffect(() => {
    return this.actions$.pipe( 

      ofType(TagActions.loadTags),
      concatMap(() =>
        /** An EMPTY observable only emits completion. Replace with your own observable API request */
        EMPTY.pipe(
          map(data => TagActions.loadTagsSuccess({ data })),
          catchError(error => of(TagActions.loadTagsFailure({ error }))))
      )
    );
  });



  constructor(private actions$: Actions) {}

}
